var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabnewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    fill: "white",
    stroke: "#004276"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_1932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6172 17.1218V42.618C22.6172 47.2473 26.37 51.0002 30.9993 51.0002C35.6286 51.0002 39.3814 47.2473 39.3814 42.618V15.6777L22.6172 17.1218Z",
    fill: "url(#paint0_linear_1035_1932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3933 30.6445V42.5252C37.3933 46.0531 34.5333 48.9132 31.0052 48.9132C27.4773 48.9132 24.6172 46.0532 24.6172 42.5252V32.0651L37.3933 30.6445Z",
    fill: "url(#paint1_linear_1035_1932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4415 34.9178C34.9659 34.4882 37.626 32.5235 37.383 30.5296C37.1399 28.5357 34.0857 27.2676 30.5613 27.6972C27.0368 28.1268 24.3767 30.0915 24.6198 32.0854C24.8628 34.0793 27.917 35.3474 31.4415 34.9178Z",
    fill: "#B3EEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2195 41.3539C29.2036 41.3539 30.0014 40.5561 30.0014 39.572C30.0014 38.5878 29.2036 37.79 28.2195 37.79C27.2353 37.79 26.4375 38.5878 26.4375 39.572C26.4375 40.5561 27.2353 41.3539 28.2195 41.3539Z",
    fill: "url(#paint2_radial_1035_1932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7902 44.3288C34.2999 44.3288 34.7131 43.9156 34.7131 43.4059C34.7131 42.8961 34.2999 42.4829 33.7902 42.4829C33.2804 42.4829 32.8672 42.8961 32.8672 43.4059C32.8672 43.9156 33.2804 44.3288 33.7902 44.3288Z",
    fill: "url(#paint3_radial_1035_1932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3492 17.8454H40.3494V15.54L21.6523 17.2229L21.6529 19.5555C21.6818 20.7684 22.4321 21.9229 23.9335 22.7896C27.314 24.7414 33.2187 24.4966 37.1221 22.2429C39.3 20.9855 40.3942 19.3684 40.3492 17.8454Z",
    fill: "url(#paint4_linear_1035_1932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6454 21.6749C36.7969 21.0469 40.685 18.1752 40.3297 15.2608C39.9744 12.3464 35.5103 10.4928 30.3588 11.1208C25.2074 11.7488 21.3192 14.6204 21.6745 17.5348C22.0298 20.4493 26.4939 22.3028 31.6454 21.6749Z",
    fill: "#E9E5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7385 19.1332C38.7593 17.3891 39.0875 14.7508 36.4713 13.2404C33.8551 11.73 29.2854 11.9194 26.2646 13.6635C23.2437 15.4076 22.9157 18.0459 25.5318 19.5563C28.1479 21.0667 32.7176 20.8773 35.7385 19.1332Z",
    fill: "url(#paint5_linear_1035_1932)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_1932",
    x1: 22.6172,
    y1: 33.339,
    x2: 41.0117,
    y2: 33.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#E9E5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_1932",
    x1: 21.1344,
    y1: 39.7789,
    x2: 39.6766,
    y2: 39.7789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60AA5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#62AE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#69BA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#75CF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#80E37B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1035_1932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2195 39.572) scale(1.78195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#E3F9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#D5F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#B3EEB0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1035_1932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7902 43.4059) scale(0.922968 0.92297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#E3F9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#D5F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#B3EEB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1035_1932",
    x1: 21.6523,
    y1: 15.54,
    x2: 40.3506,
    y2: 15.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#D7D1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1035_1932",
    x1: 23.7656,
    y1: 12.2207,
    x2: 38.2375,
    y2: 12.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#D7D1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E5F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_1932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabnewicon);
export default __webpack_public_path__ + "static/media/labnewicon.4981e88a46d6fc259330e7c558f3fe1d.svg";
export { ForwardRef as ReactComponent };